import React, { useEffect } from "react";
import { getSurveyForm } from "../../Utils/surveyFunctions";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

let Survey = () => {
  const navigate = useNavigate();
  const { formKey } = useParams();

  useEffect(() => {
    async function fetchAPI1() {
      const response = await getSurveyForm(formKey);
      if (response.status === "success") {
        if (
          response.getParticipantLastAction === "survey_open" &&
          response.getParticipantQualificationStatus === "yes"
        ) {
          navigate("/SurveyParticipantQualification/" + formKey);
        }
      } else {
        navigate("/Survey404/" + formKey);
      }
    }
    fetchAPI1();
  }, []);

  return (
    <div>
      <ToastContainer></ToastContainer>
    </div>
  );
};

export default Survey;
